(function () {
  const styleText = `
    form[data-testid="form"] {
      display: grid !important;
      grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
      gap: 12px !important;
    }
    form[data-testid="form"] > div:first-child,
    form[data-testid="form"] > button {
      grid-column: 1 / -1 !important;
    }
    form[data-testid="form"] > div:has(input[data-testid="field-first_name"]),
    form[data-testid="form"] > div:has(input[data-testid="field-email"]) {
      grid-column: span 1 !important;
    }
    /* Shopify Forms reserves space for an empty internal heading. Keep the
       fields close to the reservation label while retaining the form layout. */
    [class*="_formHeader_"] {
      height: 0 !important;
      min-height: 0 !important;
      margin: 0 !important;
      overflow: hidden !important;
    }
    [class*="_gridItemContent_"] {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
    @media (max-width: 749px) {
      form[data-testid="form"] {
        grid-template-columns: 1fr !important;
      }
      form[data-testid="form"] > div:has(input[data-testid="field-first_name"]),
      form[data-testid="form"] > div:has(input[data-testid="field-email"]) {
        grid-column: 1 / -1 !important;
      }
    }
  `;

  function applyFormLayout() {
    document.querySelectorAll('shopify-forms-embed').forEach((host) => {
      const root = host.shadowRoot;
      if (!root || root.querySelector('[data-velori-form-layout]')) return;
      const style = document.createElement('style');
      style.dataset.veloriFormLayout = 'true';
      style.textContent = styleText;
      root.appendChild(style);
    });
  }

  applyFormLayout();
  document.addEventListener('DOMContentLoaded', applyFormLayout, { once: true });
  new MutationObserver(applyFormLayout).observe(document.documentElement, { childList: true, subtree: true });
})();
